var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.breadcrumbItems)?_c('v-breadcrumbs',{staticClass:"manage-bread-crumb__breadcrumb",attrs:{"items":_vm.breadcrumbItems,"large":"","dark":""},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{attrs:{"to":item.to,"active-class":"none"}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}],null,false,3638651044)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }